// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-title[data-v-fb9aa056]{width:100%}.card-compliance[data-v-fb9aa056]{font-size:14px;margin-top:10px;font-size:13px;font-weight:lighter}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
